import React from "react";
import ReactDOM from "react-dom";
import { Container } from "./styled";

const RelativePercentageDiv = ({ leftValue, rightValue }) => {
  return (
    <Container>
      <div className="left-percentage" style={{ width: `${leftValue}%` }}></div>
      <div
        className="right-percentage"
        style={{ width: `${rightValue}%` }}
      ></div>
    </Container>
  );
};
export default RelativePercentageDiv;
